import { PropsWithChildren } from 'react'
import { Box, Flex } from '@chakra-ui/react'

type Props = {
  icon: React.ReactNode
  fontWeight?: number
}

const OrderItemInfoWithIcon = (props: PropsWithChildren<Props>): JSX.Element => {
  const { icon, fontWeight, children } = props

  return (
    <Flex alignItems="center" gridGap="6px">
      <Flex
        alignItems="center"
        justifyContent="center"
        width="24px"
        height="24px"
        gridGap="10px"
        borderRadius="50%"
        background="leid.grnn"
        color="leid.mrkGrnn"
      >
        {icon}
      </Flex>
      <Box fontSize="smd" fontWeight={fontWeight ?? 300}>
        {children}
      </Box>
    </Flex>
  )
}

export default OrderItemInfoWithIcon
